import { useMediaQuery } from '@mui/material';

const useIsMobile = () => {
  const isMobile = useMediaQuery('(max-width: 500px)');
  return isMobile;
};

export default useIsMobile;
